import React from "react";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";

const PrivateRoute = ({ isAuthenticated, element, list }) => {
  const { t } = useTranslation();
  if (!isAuthenticated) {
    toast.error(t("you_must_login_to_access"));
    return <Navigate to="/login" replace />;
  }
  return element;
};
export default PrivateRoute;
